"use strict";

var _interopRequireDefault = require("/Users/john/Desktop/Projects/nq-component/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("/Users/john/Desktop/Projects/nq-component/node_modules/@babel/runtime/helpers/esm/slicedToArray.js"));
var _objectWithoutProperties2 = _interopRequireDefault(require("/Users/john/Desktop/Projects/nq-component/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js"));
var _react = _interopRequireDefault(require("react"));
var _excluded = ["children"];
var _jsxFileName = "/Users/john/Desktop/Projects/nq-component/src/Layout/index.js";
var Context = /*#__PURE__*/_react["default"].createContext({});
function Layout(_ref) {
  var children = _ref.children,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _React$useState = _react["default"].useState(false),
    _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
    collapsed = _React$useState2[0],
    setCollapse = _React$useState2[1];
  function getValue() {
    return {
      collapsed: collapsed,
      setCollapse: setCollapse
    };
  }
  return /*#__PURE__*/_react["default"].createElement(Context.Provider, {
    value: getValue(),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 13,
      columnNumber: 12
    }
  }, children);
}
Layout.Context = Context;
var _default = exports["default"] = Layout;